import React, { useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

export default function PPMExport() {
  const [month, setMonth] = useState(""); // yyyy-mm
  const [loading, setLoading] = useState(false);

  const exportMonthly = async () => {
    if (!month) {
      alert("Pick a month first");
      return;
    }

    setLoading(true);

    try {
      const colRef = collection(db, "ppmjobs"); // change if needed

      // 🔥 Key point: you're already storing yearMonth — USE IT
      const q = query(
        colRef,
        where("yearMonth", "==", month)
      );

      const snap = await getDocs(q);

      if (snap.empty) {
        alert("No jobs found for that month");
        return;
      }

      const data = snap.docs.map(d => d.data());

      // -------------------------
      // HEADER (keep this aligned)
      // -------------------------
        const header = [
        "Status",
        "Task Name",
        "Asset",
        "Asset Code",
        "Engineer",
        "Engineer ID",
        "Due Date",
        "Completed Date",
        "Created",
        "Time (mins)",
        "Time Label",
        "Completion Notes",
        "Checklist Count",
        "Cadence",
        "Schedule Type",
        "Acknowledged By",
        "Task ID"
        ];

        const rows = data.map(r => {
        return csv([
            r.status || "",
            r.taskName || "",
            r.assetName || "",
            r.assetCode || "",
            r.completedByEngineerName || r.assignedEngineerName || "",
            r.completedByEngineerId || r.assignedEngineerId || "",
            fmtDate(r.dueDate),
            fmtDate(r.completedAt), // ✅ FIXED
            fmtDate(r.createdAt),
            r.timeTakenMins || 0,   // ✅ ADDED
            r.timeTakenLabel || "", // ✅ ADDED
            r.completionNotes || "",// ✅ FIXED (was notes)
            Array.isArray(r.checklist) ? r.checklist.length : 0,
            stringify(r.cadence),
            stringify(r.scheduleChoice),
            r.acknowledgedBy || "",
            r.taskId || ""
        ]);
        });

      const csvFile = [header.join(","), ...rows].join("\n");

      download(csvFile, `jobs_${month}.csv`);

    } catch (err) {
      console.error(err);
      alert("Export failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white border rounded-xl p-4 shadow-sm">
      <h2 className="text-lg font-semibold mb-3">Monthly Job Export</h2>

      <div className="flex items-end gap-3">
        <div>
          <label className="block text-xs text-gray-600 mb-1">Month</label>
          <input
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            className="border rounded-md p-2"
          />
        </div>

        <button
          onClick={exportMonthly}
          disabled={loading}
          className="px-4 py-2 border rounded-md bg-gray-900 text-white"
        >
          {loading ? "Exporting…" : "Export CSV"}
        </button>
      </div>
    </div>
  );
}

/* ---------------- utils ---------------- */

function fmtDate(v) {
  if (!v) return "";
  if (v?.toDate) return v.toDate().toLocaleString();
  return new Date(v).toLocaleString();
}

function stringify(obj) {
  if (!obj) return "";
  return JSON.stringify(obj).replace(/"/g, '""');
}

function csv(arr) {
  return arr
    .map((x) => {
      const s = (x ?? "").toString().replace(/"/g, '""');
      return /[",\n]/.test(s) ? `"${s}"` : s;
    })
    .join(",");
}

function download(content, filename) {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();

  URL.revokeObjectURL(url);
}